import React from 'react'
import DateOfDay from 'components/date/dateOfDay'
import ActualWeather from 'components/weather/weather'
import Breadcrumb from 'components/breadcrumb/breadcrumb'
import "./header.scss"
export default function Header(props) {
    const {crumbs, selected} = props
    return (
        <header className='flex column'>
            <section className='flex between row'>
                <div className="meteo">  
                    <ActualWeather/>
                    <div className="temperature blanc" id="temperature"></div>
                </div>
                <img src="/logo.png" alt="logo"/>
                <DateOfDay/>
            </section>
            <section style={{fontSize : "30px", height : "40px"}}>
                
            </section>
            {/* <Breadcrumbs aria-label="breadcrumb" style={{margin : "auto", height : "45px"}} className="flex alignCenter">
                {
                    breadcrumb.map(e => <p style={{color :"white", fontSize : "20px"}}>{e}</p>)
                }
            </Breadcrumbs> */}
            <Breadcrumb crumbs={ crumbs } selected={ selected }  />
        </header>
    )
}
